import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterQualifying from 'views/teacher/qualifying/filterQualifying'; // Importing FilterQualifying component
import TableQualifying from 'views/teacher/qualifying/tableQualifying'; // Importing TableQualifying component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the qualifying view.
 * @extends JetView
 */
export default class qualifyingView extends JetView {
    /**
     * Configures the layout of the qualifying view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration
        const right = {}; // Placeholder for right-side components (not used in this fragment)

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: 15, // Number of items per page
                },
            ],
        };

        // Left-side layout configuration
        const left = {
            container: 'layout_div', // Container for the left layout
            Width: 250, // Width of the left layout
            responsiveCell: false, // Responsive behavior setting
            css: 'left', // CSS class for styling
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left layout
                    css: theme, // Applying the current theme
                    elements: [
                        { view: 'label', label: _('Clasificador'), width: 160 }, // Label with localization
                    ],
                },
                FilterQualifying, // Including the FilterQualifying component
                TableQualifying, // Including the TableQualifying component
                toolbar, // Including the toolbar
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Returning the main layout configuration
        return {
            type: 'wide', // Layout type
            responsive: true, // Responsive behavior setting
            css: 'out', // CSS class for styling
            cols: [
                left, // Left layout
                { view: 'resizer' }, // Resizer component for adjusting layout
            ],
        };
    }
}

// FILE DOCUMENTED
